/**
 * Ren logik för vad en användares lägenheter innebär för ansökningsflödet.
 *
 * Hålls fri från Firestore så den kan testas direkt — anroparen läser
 * dokumenten, den här funktionen tolkar dem.
 */

const PENDING_OWNERSHIP_STATUS = 'PENDING_APPROVAL';

const hasAssociation = (apartment) =>
  Boolean(apartment?.associationId && String(apartment.associationId).trim() !== '');

/**
 * @param {object} params
 * @param {Array}  params.ownedApartments   Housing-dokument där användaren står som ownedBy.
 * @param {Array}  params.claimedApartments Housing-dokument där användaren står som claimedBy.
 * @returns {{
 *   hasAssociationApartments: boolean,
 *   apartmentsWithAssociation: Array,
 *   apartmentsWithoutAssociation: Array,
 *   hasPendingClaim: boolean
 * }}
 */
export function summarizeApartmentAccess({ ownedApartments = [], claimedApartments = [] } = {}) {
  const apartmentsWithAssociation = ownedApartments.filter(hasAssociation);
  const apartmentsWithoutAssociation = ownedApartments.filter((a) => !hasAssociation(a));

  // Ett väntande anspråk saknar ownedBy tills Hyria godkänt det, så det syns
  // aldrig i ownedApartments — det är just därför användaren annars möts av
  // "Din förening är inte medlem i Hyria".
  const hasPendingClaim = claimedApartments.some(
    (a) => a?.ownershipStatus === PENDING_OWNERSHIP_STATUS
  );

  return {
    hasAssociationApartments: apartmentsWithAssociation.length > 0,
    apartmentsWithAssociation,
    apartmentsWithoutAssociation,
    hasPendingClaim,
  };
}
